"use client"

interface StatusBadgeProps {
  style: { bg: string; text: string }
  label: string
}

export function StatusBadge({ style, label }: StatusBadgeProps) {
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 500,
        background: style.bg,
        color: style.text,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  )
}
